// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__7a4kS","label":"Radio_label__1xiEB","checkMark":"Radio_checkMark__klboJ","disabled":"Radio_disabled__3is1M"};